import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';
import indigo from '@material-ui/core/colors/indigo';

import {
  startRemoveWebsiteTestimonial,
} from 'store/actions/website';
import { ConfirmDialog } from 'components/admin/Dialogs';

const styles = theme => ({
  root:{
    margin: theme.spacing.unit*2,
    width: '350px',
    display: 'flex',
    flexDirection: 'column',
  },
  avatar: {
    color: '#fff',
    backgroundColor: indigo[300],
  },
  content: {
    backgroundColor: indigo[50],
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    '&:hover': {
      cursor: 'pointer',
    }
  },
  header: {
    '&:hover': {
      cursor: 'pointer',
    }
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: theme.spacing.unit*2,
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    width: '150px',
  }
});

class WebsiteTestimonialCard extends Component{
  constructor(props) {
    super(props);
    this.state = { showDelete: false };
  }

  handleCancel = () => {
    this.setState({ showDelete: false });
  }

  handleDelete = () => {
    const { testimonial, startRemoveWebsiteTestimonial } = this.props;
    startRemoveWebsiteTestimonial(testimonial.id);
    this.setState({ showDelete: false });
  }

  render() {
    const {
      classes,
      testimonial,
      handleDialog,
      startRemoveWebsiteTestimonial
    } = this.props;
    const { showDelete } = this.state;

    return(
      <div>
        <ConfirmDialog
          open={showDelete}
          title="Delete Service"
          contentText="This action will delete the service. Proceed?"
          handleCancel={this.handleCancel}
          handleOk={this.handleDelete}
        />
        <Card
          className={classes.root}
        >
          <CardHeader
            className={classes.header}
            action={
              <FormControlLabel
                className={classes.show}
                control={
                  <Switch
                    disabled
                    color="primary"
                    checked={testimonial.show}
                  />
                }
                label={testimonial.show ? "show" : "hide"}
              />
            }
            avatar={
              <Avatar className={classes.avatar}>
                T
              </Avatar>
            }
            title={testimonial.title}
            onClick={() => handleDialog(testimonial)}
          />
          <CardContent
            className={classes.content}
            onClick={() => handleDialog(testimonial)}
          >
            <div className={classes.row}>
              <div className={classes.column}>
                <Typography variant="caption">Name</Typography>
                <Typography>{testimonial.name}</Typography>
              </div>
              <div className={classes.column}>
                <Typography variant="caption">Location</Typography>
                <Typography>{testimonial.location}</Typography>
              </div>
            </div>
            <div>
              <Typography variant="caption">Description</Typography>
              <Typography>{testimonial.description}</Typography>
            </div>

          </CardContent>
          <CardActions>
            <Button onClick={() => this.setState({ showDelete: true })}>
              Delete
            </Button>
          </CardActions>
        </Card>
      </div>
    );
  }
}

const mapDispatchToProps = {
  startRemoveWebsiteTestimonial,
};

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps),
)(WebsiteTestimonialCard);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Testimonials/WebsiteTestimonialCard.jsx